import { Breadcrumb, Col, Row, Space } from "antd";
import { Link } from "react-router-dom";
import './assets/css/styles.scss';
import { ReactComponent as Clock } from '../../assets/images/clock.svg';
import { Editor } from "@tinymce/tinymce-react";
import { useLazyGetIntroQuery } from "./redux/IntroApi";
import { useCallback, useEffect } from "react";

const Intro = () => {
    const [contentTrigger, contentResponse] = useLazyGetIntroQuery();
    const [timeTrigger, timeResponse] = useLazyGetIntroQuery();
    const divRef = useCallback((node: HTMLDivElement | null) => {
        if (node !== null) {
            node.scrollIntoView({ behavior: 'smooth' })
        }
    }, [])

    useEffect(() => {
        contentTrigger("CONTENT");
        timeTrigger("TIME_WORK");
    }, [contentTrigger, timeTrigger])

    return (
        <div
            ref={divRef}
            style={{
                paddingTop: 40,
                paddingBottom: 40,
                // padding: '60px calc((100vw - 1500px) / 2) 60px',
                background: "#ececec",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
            }}
        >
            <Space style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }} className="responsive-padding-1440">
                <Breadcrumb separator="  " className="custom-breadcrumb">
                    <Breadcrumb.Item>
                        <Link to="/">
                            Trang chủ
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        Giới thiệu
                    </Breadcrumb.Item>
                </Breadcrumb>
                <div className="responsive-title">GIỚI THIỆU</div>
            </Space>

            <div className="responsive-padding-1440">
                <Row gutter={[50, 30]} className="intro-page">
                    <Col span={16} className="left-intro" style={{ background: 'white', borderRadius: 15 }} >
                        <div className="editor">
                            <Editor
                                tinymceScriptSrc="/tinymce/tinymce.min.js"
                                value={contentResponse.data?.content || ""}
                                init={{
                                    menubar: false,
                                    toolbar: false,
                                    content_style: 'body { font-family:Times New Roman; font-size:13px; margin: 0 }',
                                    contextmenu: false,
                                    plugins: ['autoresize']
                                }}
                                disabled
                            />
                        </div>
                    </Col>
                    <Col span={8} className="right-intro">
                        <div className="time-box editor">
                            <div><Clock style={{ marginRight: 15 }} /> Thời gian làm việc</div>
                            <Editor
                                tinymceScriptSrc="/tinymce/tinymce.min.js"
                                value={timeResponse.data?.content || ""}
                                init={{
                                    menubar: false,
                                    toolbar: false,
                                    content_style: 'body { font-family:Times New Roman; font-size:13px; margin: 0 }',
                                    contextmenu: false,
                                    plugins: ['autoresize']
                                }}
                                disabled
                            />
                        </div>
                    </Col>
                </Row>
            </div>

        </div >
    )
}
export default Intro;